export default __webpack_public_path__ + "static/media/family.5003e972.svg";